import { render, staticRenderFns } from "./ExtraCreate.vue?vue&type=template&id=588eefd4&scoped=true"
import script from "./ExtraCreate.vue?vue&type=script&lang=js"
export * from "./ExtraCreate.vue?vue&type=script&lang=js"
import style0 from "./ExtraCreate.vue?vue&type=style&index=0&id=588eefd4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588eefd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588eefd4')) {
      api.createRecord('588eefd4', component.options)
    } else {
      api.reload('588eefd4', component.options)
    }
    module.hot.accept("./ExtraCreate.vue?vue&type=template&id=588eefd4&scoped=true", function () {
      api.rerender('588eefd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contacts/ExtraCreate.vue"
export default component.exports